<template>
    <el-button v-bind="$attrs" @click="pay()">
        <slot>支付</slot>
    </el-button>
</template>

<script type="text/javascript">

export default {
    props: {
        url: {
            type: String,
            required: true
        },
      PayAmout: {
        type:Number,
        default: 600
      },
      paymentType: {
        type:Number,
        default: 1
      }
    },
    methods: {
        pay() {
            var self = this;
            self.$emit('beforePay')
            self.$http.post(self.url, {
              Data: {
                PayAmout:self.PayAmout,
                PaymentType: self.paymentType
              }
            })
            .then(res => { 
                if(res.State == 1) {
                    self.$emit('onpay', res.Message);

                    setTimeout(() => {
                      var doc = window.document;
                      let param = {
                        data:res.Data
                      }
                      window.sessionStorage.setItem("html",res.Data);
                      let routeData = self.$router.resolve({
                        path: '/Pay',
                        name: 'Pay',
                        params: param
                      })
                      window.open(routeData.href, '_blank')
                    }, 100);
                }
                else {
                    self.$message.error(res.Message);
                    self.$emit('cannotpay');
                }
            }, () => {
                self.$message.error('支付环境异常，请检查您的网络环境是否安全！');
                self.$emit('cannotpay');
             });
        },
    }
}
</script>



// WEBPACK FOOTER //
// src/components/Buttons/PayButton.vue